import React, { useEffect, useState } from 'react';
import Topbar from '../components/Topbar';
import Leftbar from '../components/Leftbar';
import { Link } from 'react-router-dom';
import { deactivateUser, getCarousel } from '../Utils/utils';
import { toggleLoader } from '../actions/loader';
import config from '../config/config';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import axios from 'axios';
import { displayError, displaySuccess } from '../Utils/utils';
import ReactPaginate from 'react-paginate';

const Carousel = (props) => {
  const [list, setList] = useState([]);
  const [tempVarId, setTempVarId] = useState('');
  const [is_delete, setIsDelete] = useState(false);

  useEffect(async () => {
    props.toggleLoader(true);
    var getCarousel_var = await getCarousel();
    setList(getCarousel_var)
    props.toggleLoader(false);
  }, [])

  const deleteCarousel = async () => {
    var token = localStorage.getItem('token');
    props.toggleLoader(true);
    let path = config.siteUrl;
    axios.get(path + "/admin/carousel/delete/" + tempVarId, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    })
      .then(async (response) => {
        props.toggleLoader(false);
        displaySuccess('Deleted Successfully');
        var getCarousel_var = await getCarousel();
        setList(getCarousel_var)
      })
      .catch(function (error) {
        props.toggleLoader(false);
        displayError(error);
      });
  }
  return (
    <>
      <body class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar />
          <main className="main-content border-radius-lg">
            <Topbar
            // search_method={searchUser}
            />

            <div className="header bg-primary pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                          <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                          <li className="breadcrumb-item"><a href="#">Carousel Management</a></li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="row">
                        <div className="col-6">
                          <h3 className="mb-0">Carousel Management</h3>
                        </div>
                        <div class="col-6 text-right">
                          <Link to='/carousel-management/add'>
                            <a href="" class="btn btn-dark mr-2" data-toggle="tooltip" data-original-title="Edit product">
                              <span class="btn-inner--icon"><i class="fas fa-user-edit"></i></span>
                              <span class="btn-inner--text"> Add Carousel</span>
                            </a>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                          <th> Head Text</th>
                            <th> Description</th>
                            <th>Image</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.map((user) => (
                            <tr>
                               <td className="table-user">
                                <b>{user.head_text} </b><br/><br/>
                                <b>({user.head_text_pt})</b>
                              </td>
                              <td className="table-user">
                                <b>{user.description}</b><br/><br/>
                                <b>({user.description_pt})</b>
                              </td>
                              <td className="table-user">

                                <img src={user.media.url} style={{ maxWidth: '200px' }} />
                              </td>
                              <td className="table-actions">
                                <Link to={'carousel-management/edit/' + user.id}>
                                  <a className="items-center m-1 btn-outline-dark btn btn-sm">
                                    {<i className="far fa-edit"></i> /* {I18n.t('Edit')} */}
                                  </a>
                                </Link>
                                <button className="flex items-center btn btn-sm  btn-outline-danger"
                                  onClick={e => {
                                    setTempVarId(user.id)
                                    setIsDelete(true)
                                  }}
                                >
                                  <i className="far fa-trash-alt" /> </button>
                              </td>
                            </tr>
                          ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>


              <div>
                {/* <ReactPaginate
                  previousLabel={"prev"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  // pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  // onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"} /> */}
              </div>
            </div>
            {is_delete === true ? (
              <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes"
                confirmBtnBsStyle="danger"
                title='Are you sure?'
                onConfirm={(e) => {
                  deleteCarousel()
                  setIsDelete(false)
                  // window.location.reload(false)
                }}
                onCancel={(e) => {
                  setIsDelete(false)
                  setTempVarId('')
                }}
                focusCancelBtn
              >
                Do you want to delete this user?
              </SweetAlert>
            ) : ([]
            )}

          </main>
        </div>
      </body >
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = (state) => {
  return {
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Carousel);
